const CoffeeFlavorAcidity = [

  {
    "name": "Bright"
  },
  {
    "name": "Crisp"
  },
  {
    "name": "Delicate"
  },
  {
    "name": "Harsh"
  },
  {
    "name": "Subtle"
  },
  {
    "name": "Overpowering"
  },
  {
    "name": "Clean"
  }
]
;

export default CoffeeFlavorAcidity;



// WEBPACK FOOTER //
// ./src/components/CoffeeFlavorAcidity.js